import {requestOptions} from "./base";

export const createCustomerList = () => (
  requestOptions('customerList', {
    method: 'POST',
  })
);

export const getCustomerLists = () => (
  requestOptions('customerList', {
    method: 'GET',
  })
);

export const removeCustomerList = () => (
  requestOptions(`customerList/delete`, {
    method: 'POST',
  })
);

